import React from 'react';
import classnames from 'classnames';
import { bool, node } from 'prop-types';

const Detail = ({
  children,
  className,
  start,
  end,
  ...props
}) => (
  <div
    {...props}
    className={classnames([
      {
        'mdc-list-item__graphic': start,
        'mdc-list-item__meta': end,
      },
      className,
    ])}
  >{children}
  </div>
);

Detail.propTypes = {
  children: node.isRequired,
  start: bool,
  end: bool,
};

Detail.defaultProps = {
  start: false,
  end: false,
};

export default Detail;
